import { Suspense } from 'react'
import { AppBar, Divider, Toolbar } from '@mui/material'
import styled from 'styled-components/macro'
import { UserDropdownMenu } from 'src/components/Topbar/UserDropdownMenu'
import { palette, spacing, theme } from 'src/utils/styled'
import traiwissLogo from 'src/assets/traiwiss_logo.png'
import { LogoutButton } from './LogoutButton'
import { SearchInput } from './SearchInput'

const StyledAppBar = styled(AppBar)`
    z-index: ${theme((t) => t.zIndex.drawer + 1)};
`

const StyledToolbar = styled(Toolbar)`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const StyledDiv = styled.div`
    display: flex;
    align-items: center;
`

const StyledImage = styled.img`
    height: 30px;
    margin: ${spacing(1)};
`

const StyledDivider = styled(Divider)`
    border-color: ${palette((p) => p.secondary.contrastText)};
    opacity: 0.5;
`

export function Topbar() {
    return (
        <Suspense fallback={<></>}>
            <StyledAppBar position="fixed" color="secondary">
                <StyledToolbar>
                    <a href="/">
                        <StyledImage src={traiwissLogo} alt="traiwiss logo" />
                    </a>
                    <SearchInput />
                    <StyledDiv>
                        <StyledDivider orientation="vertical" variant="middle" light flexItem />
                        <UserDropdownMenu />
                        <LogoutButton />
                    </StyledDiv>
                </StyledToolbar>
            </StyledAppBar>
        </Suspense>
    )
}
